import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { TextFields } from "@mui/icons-material";

/**
 * Text Node — Manipular texto (upper, lower, replace, split, trim, etc).
 *
 * data.operation: "uppercase" | "lowercase" | "trim" | "replace" | "split" | "join" | "substring" | "length"
 * data.sourceVar: string — variavel de entrada
 * data.outputVar: string — variavel de saida
 * data.param1: string — parametro 1 (search, delimiter, start index)
 * data.param2: string — parametro 2 (replace value, end index)
 */
const TextNode = memo(({ id, data, isConnectable, selected }) => {
  const operation = data?.operation || "uppercase";
  const sourceVar = data?.sourceVar || "";
  const outputVar = data?.outputVar || "";

  const opLabels = {
    uppercase: "MAIUSCULAS",
    lowercase: "minusculas",
    trim: "Trim",
    replace: "Substituir",
    split: "Dividir",
    join: "Juntar",
    substring: "Substring",
    length: "Tamanho",
  };

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<TextFields />}
      title="Texto"
      color="#6D4C41"
      bgColor="#EFEBE9"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#6D4C41", borderRadius: 4, padding: "1px 8px",
          }}>{opLabels[operation] || operation}</span>
        </div>
        {sourceVar && (
          <div style={{ marginTop: 4, fontFamily: "'Fira Code', monospace", color: "#666", fontSize: 10 }}>
            ${"{" + sourceVar + "}"} → ${"{" + (outputVar || "resultado") + "}"}
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});

TextNode.displayName = "TextNode";
export default TextNode;
